const defaultDropdown = {

	data() {
		return {
			scrollWidth: '',
			visualState: false,
			isOpenTab: false,
			moving: {
				isTouchScrollForVisualSwitch: false,
				isActive: false,
				isShadow: true,
				isTouch: false,
				activeIndex: 0,
				isLastRevert: false
			},
			scrollBar: {
				height: '',
				top: ''
			},
			mouseOver: false,
			visibleItemCount: 4,
			initialHeight:  false,
			dropListHeight: null
		}
	},

	computed: {
		wrapStyleObj() {
			if (this.settings.condition.order && this.settings.condition.order.isOrder)
				return {
					order: this.settings.condition.order.number
				}
		},
	},

	methods: {
		checkShadow(e) {
			const dropdown = this.$refs.dropList.getBoundingClientRect();
			const item = e.target.getBoundingClientRect();

			const isLastElement = () =>
				item.top - dropdown.top >= dropdown.height - item.height;

			if (this.moving.isLastRevert)
				isLastElement() ?
					this.moving.isShadow = false :
					this.moving.isShadow = true;
		},
		activateShadow() {
			if (this.moving.isLastRevert) this.moving.isShadow = true;
		},
		useScrollBar() {
			const scrollVis = this.$refs.dropList;
			const scrollWrap = this.$refs.scrollBarWrap;

			let scrollHeight;
			let scrollHeightCoef;
			if (scrollVis)
				scrollHeight = (scrollWrap.clientHeight * scrollVis.clientHeight / scrollVis.scrollHeight);

			this.scrollBar.height = scrollHeight;

			scrollHeight > 30 ?
				scrollHeightCoef = 0 :
				scrollHeightCoef = 30;


			let scrollTop = (scrollWrap.clientHeight - scrollHeightCoef) * scrollVis.scrollTop / scrollVis.scrollHeight;

			if (!this.moving.isTouch)
				this.scrollBar.top = scrollTop;

			this.lastElScroll();
		},
		behaviorScroll(start) {
			const scrollVis = this.$refs.dropList;
			const scroll = this.$refs.scrollBar;
			const scrollWrap = this.$refs.scrollBarWrap;
			const offsetTop = scroll.offsetTop;

			const move = end => {
				this.moving.isTouch = true;
				this.moving.isTouchScrollForVisualSwitch = true;
				const delta = end.pageY - start.pageY;

				let scrollHeight;
				if (scrollVis)
					scrollHeight = (scrollWrap.clientHeight * scrollVis.clientHeight / scrollVis.scrollHeight);

				let scrollHeightCoef;
				scrollHeight > 30 ?
					scrollHeightCoef = scrollHeight :
					scrollHeightCoef = 30;

				this.scrollBar.top =
					Math.min(scrollWrap.clientHeight - scrollHeightCoef, Math.max(0, offsetTop + delta));

				scrollVis.scrollTop =
					(scrollVis.scrollHeight * scroll.offsetTop / (scrollWrap.clientHeight - scrollHeightCoef));
				this.lastElScroll();
			};
			document.addEventListener('mousemove', move);
			document.addEventListener('mouseup', () => {
				document.removeEventListener('mousemove', move);
				this.moving.isTouch = false;
				setTimeout(() => {
					this.moving.isTouchScrollForVisualSwitch = false;
				}, 100)
			});
		},
		changeVisualSwith(arr, openStatus = false) {
			if (!this.moving.isTouchScrollForVisualSwitch) {
				if (!this.initialHeight) {
					this.autoHeight();
					this.initialHeight = true;
				}
				this.useScrollBar();

				const el = this.$refs.dropList;
				let scrollWidth = el.offsetWidth - el.clientWidth;
				this.scrollWidth = scrollWidth;

				this.$root.$el.removeEventListener('click', this.visualSwitch);
				setTimeout(() => {
					this.visualState = !this.visualState;
					if (openStatus)
						this.$emit('open', this.visualState);
					this.visualState ? (
						this.moving.isActive = true,
							this.isOpenTab = true,
							setTimeout(() => {
								if (this.$refs.searchInput)
									this.$refs.searchInput.focus()
							}, 100)
					) : (
						this.isOpenTab = false,
							this.moving.isActive = false
					);
				}, 70);


				[...this.$refs[arr]].forEach(item => item.classList.remove('active'));
				this.moving.isShadow = true;
			}
		},
		initLastElScroll(item, arr) {
			let offsetParent;
			let itemHeight;
			if (this.$refs[item][0]) {
				offsetParent =
					this.$refs[item][0].parentNode.getBoundingClientRect().y;
				itemHeight = this.$refs[item][0].getBoundingClientRect().height;

			}

			let lastElScrollOffset;

			if (this.$refs[item][arr.length - 1])
				lastElScrollOffset =
					this.$refs[item][arr.length - 1].getBoundingClientRect().y;

			let offsetCoef =
				lastElScrollOffset - offsetParent;

			offsetCoef === itemHeight * (this.visibleItemCount - 1) ?
				this.moving.isShadow = this.moving.isLastRevert = false :
				this.moving.isShadow = this.moving.isLastRevert = true;

		},
		initKeyMoving(item, arr, e) {
			const initActiveEl = (param) => {
				let offsetParent = this.$refs[item][0].parentNode.getBoundingClientRect().y;
				let heightCoef = this.$refs[item][0].clientHeight;
				if (this.moving.isActive) {
					let activeElement = [...this.$refs[item]].reduce((acc, val, idx) => {
						const diff = val.getBoundingClientRect().y - offsetParent;
						return (diff >= 0) && diff < acc.offset ? {offset: diff, index: idx} : acc
					}, {offset: Infinity});


					param === 'down' ?
						this.moving.activeIndex = activeElement.index - 1 :
						this.moving.activeIndex = activeElement.index;

					this.$refs.dropList.scrollBy({
						left: 0,
						top: activeElement.offset % heightCoef,
						behavior: 'smooth'
					});
					this.moving.isActive = false;
				}
			};

			const togglePosition = (param) => {
				e.preventDefault();
				initActiveEl(param);
				let heightCoef = this.$refs[item][0].clientHeight;

				let offsetActiveEl = 0;
				let offsetParent = this.$refs[item][0].parentNode.getBoundingClientRect().y;
				if (this.$refs[item][this.moving.activeIndex])
					offsetActiveEl = this.$refs[item][this.moving.activeIndex].getBoundingClientRect().y;

				let diff = offsetActiveEl - offsetParent;

				if (param === 'down') {
					if (this.moving.activeIndex === arr.length - 1)
						return false;

					this.moving.activeIndex++;

					if (diff === heightCoef * (this.visibleItemCount - 1))
						this.$refs.dropList.scrollBy(0, heightCoef);

					if (diff === heightCoef * (this.visibleItemCount - 1) || diff === heightCoef * (this.visibleItemCount - 2))
						setTimeout(() => {
							this.moving.isShadow = false;
						}, 50);

				} else if (param === 'up') {
					if (this.moving.activeIndex === 0) return false;
					this.moving.isShadow = true;
					this.moving.activeIndex--;


					if (diff === 0)
						this.$refs.dropList.scrollBy(0, -heightCoef)
				}

			};


			if (e.which === 38) {
				//    up
				togglePosition('up')
			} else if (e.which === 40) {
				//    down
				togglePosition('down')
			} else if (e.which === 13) {
				//    enter
				e.preventDefault();
				if (this.$refs[item][this.moving.activeIndex])
					this.$refs[item][this.moving.activeIndex].click();
			} else if (e.which === 27) {
				//    esc
				this.visualSwitch();
			}
		},
		onMouseOver(el) {
			const elPosY = el.getBoundingClientRect().top;
			const parentPosY = this.$refs.dropList.getBoundingClientRect().top;
			const height = el.getBoundingClientRect().height;

			if (elPosY - parentPosY === height * 3 && this.moving.isShadow && this.moving.isLastRevert) {
				this.mouseOver = true;
				this.moving.isShadow = false;
			}
		},
		onMouseLeave() {
			if (this.mouseOver && this.moving.isLastRevert) {
				this.moving.isShadow = true;
				this.mouseOver = false;
			}
		},
		autoHeight() {
			const windowHeight = window.innerHeight;
			const dropListHeight = this.$refs.dropList.offsetHeight;
			const offsetTop = this.$refs.dropList.getBoundingClientRect().top;
			const offsetBottom = windowHeight - dropListHeight - offsetTop;
			const vueInstance = (document.getElementById('app').__vue__).$el;
			const headerHeight = 60;
			const windowHasScrollbar = () => vueInstance.offsetHeight + headerHeight > windowHeight;

			if (!windowHasScrollbar()) {
				const searchWrap = this.$refs.searchWrap;
				const item = searchWrap ? this.$refs.searchItem : this.$refs.listItem;

				const itemHeight = (item.find(_=>_)).offsetHeight;

				offsetBottom < 10 ?
					this.visibleItemCount = 3:
					this.visibleItemCount = 4;


				this.$refs.scrollBarWrap.style.height =
					this.$refs.dropList.style.maxHeight =
						`${this.visibleItemCount * itemHeight}px`;

				let searchDropHeight = `${this.visibleItemCount * itemHeight}px`;

				if (searchWrap) {
					const searchHeight = searchWrap.offsetHeight;
					searchDropHeight  = `${this.visibleItemCount * itemHeight + searchHeight}px`;
				}

				this.dropListHeight = searchDropHeight;
			}
		}
	},
	watch: {
		visualState(val) {
			if (this.visualState)
				this.$root.$el.addEventListener('click', this.visualSwitch);
		},
	},
	mounted() {
		document.addEventListener('keydown', this.keyMoving);
		window.addEventListener('resize', this.autoHeight);
	},
	beforeDestroy() {
		document.removeEventListener('keydown', this.keyMoving);
		window.removeEventListener('resize', this.autoHeight)
	}

};

export default defaultDropdown;